import * as Sentry from '@sentry/nextjs';

export function mirrorOnRootSpan(
  attrs: Record<string, string | boolean>
): void {
  const active = Sentry.getActiveSpan();
  if (!active) return;
  const root = Sentry.getRootSpan(active);
  for (const [k, v] of Object.entries(attrs)) {
    root.setAttribute(k, v);
  }
}
